import { isFeatureEnabled } from '../features';
import { getState } from '../state';
import { fetchServiceReservations } from '../~graphql/controllers';
import { fetchProcuctCategories } from '../~graphql/controllers/fetchProductCategories';
import { fetchProcuctTypologies } from '../~graphql/controllers/fetchProductTypologies';
import { fetchDelegantiByServizio } from '../~loader/loader-api/fetchDelegantiByServizio';
import { getUser } from '~src/user';
import { getEnrichedContextDefuntoMetadata } from './getEnrichedContextDefuntoMetadata';
import { getEnrichedContextDefuntoCompanyOfficeAliases } from './getEnrichedContextDefuntoCompanyOfficeAliases';

export const getTextTemplateContext = async () => {
  let servizio = getState('selected.servizio', {});
  const card = getState('card', '');
  const templateCategory = getState('selected.templatesCategory', '');

  // Enrich metadata with resolved pointer fields
  if (servizio?.metadata) {
    servizio.metadata = await getEnrichedContextDefuntoMetadata(
      servizio.metadata
    );
  }

  servizio = getEnrichedContextDefuntoCompanyOfficeAliases(servizio);

  let deleganti = [];
  if (servizio && servizio.objectId) {
    deleganti = await fetchDelegantiByServizio(servizio.objectId);
  }

  let serviceReservation = {};
  if (
    (await isFeatureEnabled('prenotazioni.show')) &&
    servizio &&
    servizio.objectId &&
    templateCategory?.objectId
  ) {
    const enabledCategories = await fetchProcuctCategories({
      editor_templates_categories: { contains: templateCategory.objectId },
    });
    const enabledTypologies = await fetchProcuctTypologies({
      editor_templates_categories: { contains: templateCategory.objectId },
    });

    if (
      (enabledTypologies && enabledTypologies.length > 0) ||
      (enabledCategories && enabledCategories.length > 0)
    ) {
      const where = {
        defunto_pointer: {
          have: { objectId: { equalTo: servizio.objectId } },
        },
      };
      const resultServiceReservations = await fetchServiceReservations(where);

      //Filters service reservations by giotto editor template enabled typologies
      let filteredServiceReservations = resultServiceReservations.filter(
        (serviceReservation) =>
          serviceReservation?.join_servizi_service_reservation?.edges?.some(
            (product) =>
              enabledTypologies.some(
                (typology) =>
                  typology.servizi_offerti_default_pointer?.objectId ===
                  product.node.servizi_pointer.categorie_servizi_pointer
                    ?.servizi_offerti_default_pointer?.objectId
              )
          )
      );
      if (filteredServiceReservations.length > 0) {
        serviceReservation = filteredServiceReservations[0];
      } else {
        if (enabledCategories && enabledCategories.length > 0) {
          //Filters service reservations by giotto editor template enabled categories
          filteredServiceReservations = resultServiceReservations.filter(
            (serviceReservation) =>
              serviceReservation?.join_servizi_service_reservation?.edges?.some(
                (product) =>
                  enabledCategories.some(
                    (category) =>
                      category.objectId ===
                      product.node.servizi_pointer.categorie_servizi_pointer
                        ?.objectId
                  )
              )
          );
          if (filteredServiceReservations.length > 0) {
            serviceReservation = filteredServiceReservations[0];
          }
        }
      }
    }
  }

  let necrofori = [];
  if (
    servizio &&
    servizio.relation_necrofori &&
    servizio.relation_necrofori.length > 0
  ) {
    necrofori = servizio.relation_necrofori;
  }

  const { user } = await getUser();

  return { user, necrofori, servizio, card, serviceReservation, deleganti };
};
